// Joins truthy class names: cx("a", isActive && "b") -> "a b"
export const cx = (...classes) => classes.filter(Boolean).join(" ");
